import React from 'react';
import { GoogleMap } from '../GoogleMap/GoogleMap';
import { APP_CONFIG } from '../../../shared/constants/AppConfig';
import './Footer.css';

interface FooterProps {
  onContact: () => void;
}

export const Footer: React.FC<FooterProps> = ({ onContact }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <button className="contact-button" onClick={onContact} title="Entre em contato">
          <i className="fas fa-envelope"></i>
        </button>
        <p className="contact-text">
          Entre em contato para mais informações sobre nossos cursos, eventos e exposição
        </p>
        
        {/* Mapa do Google Maps */}
        <GoogleMap 
          address={APP_CONFIG.ADDRESS}
          title="Nossa Localização"
        />
        
        <div className="footer-info">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {APP_CONFIG.ORGANIZATION_NAME}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}; 